var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 5.2v-.64c0-.896 0-1.344-.175-1.686a1.6 1.6 0 0 0-.699-.7C11.984 2 11.536 2 10.64 2H9.36c-.896 0-1.344 0-1.687.174a1.6 1.6 0 0 0-.699.7c-.174.342-.174.79-.174 1.686v.64m1.6 4.4v4m3.2-4v4M2.8 5.2h14.4m-1.6 0v8.96c0 1.344 0 2.016-.262 2.53a2.4 2.4 0 0 1-1.049 1.048c-.513.262-1.185.262-2.53.262H8.24c-1.343 0-2.015 0-2.529-.262a2.4 2.4 0 0 1-1.049-1.048c-.261-.514-.261-1.186-.261-2.53V5.2",
    stroke: "#111927",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDelete;